namespace GeniuzPOS.Inventory {
    export interface IcStockBacProcessingRow {
        Id?: number;
        PostFg?: BacPostFgStatus;
        PosOrIcProcessing?: PosOrIcProcessingFgstatus;
        PostSequenceFg?: PostSequenceFgstatus;
        TotalDocCount?: number;
        TotalTranCount?: number;
        ProcessedTranCount?: number;
        CreateBy?: string;
        CreateDate?: string;
        FinishDate?: string;
    }

    export namespace IcStockBacProcessingRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'Inventory.IcStockBacProcessing';
        export const deletePermission = '2Inventory:ระบบ:ประมวลผลสิ้นวัน:Modify';
        export const insertPermission = '2Inventory:ระบบ:ประมวลผลสิ้นวัน:Modify';
        export const readPermission = '2Inventory:ระบบ:ประมวลผลสิ้นวัน:View';
        export const updatePermission = '2Inventory:ระบบ:ประมวลผลสิ้นวัน:Modify';

        export declare const enum Fields {
            Id = "Id",
            PostFg = "PostFg",
            PosOrIcProcessing = "PosOrIcProcessing",
            PostSequenceFg = "PostSequenceFg",
            TotalDocCount = "TotalDocCount",
            TotalTranCount = "TotalTranCount",
            ProcessedTranCount = "ProcessedTranCount",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            FinishDate = "FinishDate"
        }
    }
}
